import ApiHandler from '@/api/base'

class ReactionsApiHandler extends ApiHandler {
  async addReaction({ commentId, reactionCode }) {
    const { data } = await this.http.post('/reactions', {
      commentId,
      reactionCode
    })
    return data
  }

  async removeReaction({ commentId, reactionCode }) {
    const { data } = await this.http.delete('/reactions', {
      data: {
        commentId,
        reactionCode
      }
    })
    return data
  }
}
export default ReactionsApiHandler
